export const TOP_BAR_NAME_CHACACTER_LIMIT = 20;
export const DESKTOP_HEADER_HEIGHT = '110px';
